import React from "react";
import { useRouteMatch } from "react-router";
import { Link } from "react-router-dom";

import {
  Container,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import {
  AccountMultiple as UsersIcon,
  EmailOpen as TempalesIcon,
  ViewColumn as OrderStatesIcon,
  CurrencyUsd as ProductsIcon,
  Abacus as StocksIcon,
  AccountGroup as ReferralRewardsIcon,
} from "mdi-material-ui";

import Layout from "components/common/Layout";

export default function AdminPage() {
  const match = useRouteMatch();

  return (
    <Container fixed>
      <Layout.Toolbar fixed>
        <Typography variant="h4" color="primary">
          Admin Lapidou
        </Typography>
      </Layout.Toolbar>

      <List>
        <ListItem button component={Link} to={`${match.url}/users`}>
          <ListItemIcon>
            <UsersIcon />
          </ListItemIcon>
          <ListItemText primary="Utilisateurs" />
        </ListItem>

        <ListItem button component={Link} to={`${match.url}/templates`}>
          <ListItemIcon>
            <TempalesIcon />
          </ListItemIcon>
          <ListItemText primary="Templates" />
        </ListItem>

        <ListItem button component={Link} to={`${match.url}/order-states`}>
          <ListItemIcon>
            <OrderStatesIcon />
          </ListItemIcon>
          <ListItemText primary="Êtats des commandes" />
        </ListItem>

        <ListItem button component={Link} to={`${match.url}/products`}>
          <ListItemIcon>
            <ProductsIcon />
          </ListItemIcon>
          <ListItemText primary="Produits" />
        </ListItem>

        <ListItem button component={Link} to={`${match.url}/stocks`}>
          <ListItemIcon>
            <StocksIcon />
          </ListItemIcon>
          <ListItemText primary="Stocks" />
        </ListItem>

        <ListItem button component={Link} to={`${match.url}/referral-rewards`}>
          <ListItemIcon>
            <ReferralRewardsIcon />
          </ListItemIcon>
          <ListItemText primary="Récompenses de parrainage" />
        </ListItem>

        <ListItem button component={Link} to={`${match.url}/affiliations`}>
          <ListItemIcon>
            <ReferralRewardsIcon />
          </ListItemIcon>
          <ListItemText primary="Affiliations" />
        </ListItem>
      </List>
    </Container>
  );
}
